export default "__VITE_ASSET__Cnd5699M__"